var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFilter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90154 9.49255H1.68164",
    stroke: "#606474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.319 9.4925C12.319 10.4203 11.5668 11.1725 10.639 11.1725C9.71114 11.1725 8.95898 10.4203 8.95898 9.4925C8.95898 8.56397 9.71114 7.8125 10.639 7.8125C11.5668 7.8125 12.319 8.56397 12.319 9.4925Z",
    stroke: "#606474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09766 2.6532H12.3182",
    stroke: "#606474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68164 2.65314C1.68164 3.58167 2.4338 4.33314 3.36164 4.33314C4.28948 4.33314 5.04164 3.58167 5.04164 2.65314C5.04164 1.7253 4.28948 0.973145 3.36164 0.973145C2.4338 0.973145 1.68164 1.7253 1.68164 2.65314Z",
    stroke: "#606474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-filter.4528147e.svg";
export { ForwardRef as ReactComponent };